import { useEffect, useState } from "react";
import { selectUser } from "../redux/features/auth/AuthSlice";
import { useSelector } from "react-redux";

const OnlyAdmin = ({ children }) => {
    const user = useSelector(selectUser);
  return user?.role === "admin" ? <>{children}</> : null;
};

const AdminCashier = ({ children }) => {
     const user = useSelector(selectUser);


  return user?.role === "admin" || user?.role === "cashier" ? (
    <>{children}</>
  ) : null;
};

const useIsAdminOrCashier = () => {
     const user = useSelector(selectUser);

  return user?.role === "admin" || user?.role === "cashier";
};

const AdminCashierCounter = ({ children }) => {
      const user = useSelector(selectUser);

  return user?.role === "admin" || user?.role === "cashier" || user?.role === "counter" ? (
    <>{children}</>
  ) : null;
};


export { OnlyAdmin, AdminCashier, useIsAdminOrCashier ,AdminCashierCounter};
